import {connect} from 'react-redux';
import Scheduler from './Scheduler.jsx';

const mapStateToProps = state => ({
  ...state.registration.scheduler,
  marketingMessage: state.registration.base.marketingMessage,
  noDatesAvailable: state.registration.scheduler.noDatesAvailable,
  canCaptainPurchase: state.registration.base.canCaptainPurchase
});

export default connect(mapStateToProps)(Scheduler);



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/SchedulerContainer.jsx